/**
 * Tradução central de status de pedidos para português.
 * Cobre status do Auuii, iFood e Anota Aí. Usado em todas as telas
 * para garantir que nenhum status apareça em inglês.
 */

const STATUS_MAP = {
  // Genéricos / Auuii
  'PENDING': 'Pendente',
  'PENDENTE': 'Pendente',
  'NEW_ORDER': 'Novo Pedido',
  'NEW': 'Novo Pedido',
  'PENDING_PAYMENT': 'Aguardando Pagamento',
  'WAITING_PAYMENT': 'Aguardando Pagamento',
  'PAID': 'Pago',
  'CONFIRMED': 'Confirmado',
  'CONFIRMADO': 'Confirmado',
  'ACCEPTED': 'Aceito',
  'ACEITO': 'Aceito',
  'PREPARING': 'Preparando',
  'PREPARANDO': 'Preparando',
  'PREPARATION_STARTED': 'Preparando',
  'IN_PREPARATION': 'Preparando',
  'READY': 'Pronto',
  'READY_TO_PICKUP': 'Pronto para Retirada',
  'PRONTO': 'Pronto',
  'DISPATCHED': 'A Caminho',
  'A CAMINHO': 'A Caminho',
  'ON_THE_WAY': 'A Caminho',
  'OUT_FOR_DELIVERY': 'Saiu para Entrega',
  'ACCEPTED_BY_DELIVERY': 'Entregador Atribuído',
  'ALLOCATED': 'Entregador Atribuído',
  'ARRIVED_AT_RESTAURANT': 'No Restaurante',
  'COLLECTED': 'Pedido Coletado',
  'ARRIVED_AT_CLIENT': 'No Cliente',
  'DELIVERED': 'Entregue',
  'ENTREGUE': 'Entregue',
  'COMPLETED': 'Concluído',
  'CONCLUDED': 'Concluído',
  'CONCLUIDO': 'Concluído',
  'FINALIZADO': 'Concluído',
  'DLV': 'Entregue',
  'CANCELLED': 'Cancelado',
  'CANCELED': 'Cancelado',
  'CANCELADO': 'Cancelado',
  'REJECTED': 'Rejeitado',
  'REJEITADO': 'Rejeitado',
  'INTEGRATED': 'Integrado',
  'PLACED': 'Novo Pedido',
  'CREDIT_LIMIT_BLOCKED': 'Bloqueado (limite)',
};

const UNPAID_ORDER_STATUSES = new Set([
  'PENDING_PAYMENT',
  'WAITING_PAYMENT',
  'AWAITING_PAYMENT',
  'TEMPORARY',
]);

/**
 * Indica se o pedido ainda aguarda aprovação do pagamento online (Pix/cartão)
 * e, portanto, NÃO deve aparecer nos painéis, mapas, faturamento, impressão
 * automática ou histórico antes da confirmação do pagamento.
 */
export function isOrderAwaitingPayment(order) {
  if (!order || typeof order !== 'object') return false;

  const status = String(order.status || '').trim().toUpperCase();
  if (UNPAID_ORDER_STATUSES.has(status)) return true;

  const allocStatus = String(order.allocationStatus || '').trim().toUpperCase();
  if (allocStatus === 'WAITING_PAYMENT') {
    const payStatus = String(
      order.paymentStatus || order['total.status'] || order.total?.status || ''
    ).trim().toLowerCase();
    const isApproved =
      payStatus === 'approved' ||
      payStatus === 'authorized' ||
      payStatus === 'paid' ||
      payStatus === 'not_required';
    if (!isApproved) return true;
  }

  return false;
}

/**
 * Traduz um status para português.
 * Se não houver tradução exata, formata de forma legível
 * (ex.: "SOME_NEW_STATUS" → "Some New Status") em vez de deixar cru.
 */
export function translateOrderStatus(status) {
  if (!status) return 'Pendente';
  const key = String(status).trim().toUpperCase();
  if (STATUS_MAP[key]) return STATUS_MAP[key];

  // Fallback: deixa legível (sem underscores, capitalizado)
  return String(status)
    .replace(/[_-]+/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default translateOrderStatus;
